export default "__VITE_ASSET__DSH2XscD__"